// extracted by mini-css-extract-plugin
module.exports = {"consentScrollContainer":"ConsentQuestion_consentScrollContainer__m2mxZ"};